module.exports = __webpack_public_path__ + "media/stylesheets/images/folk-0f6bcaaa3c6670a42150d2fd0a0b1352.jpg";